// Centralized data for Maqam Community Initiatives website
export const TRIP = {
  title: "October 2026 Umrah",
  startDate: "2026-10-10T00:00:00",
  endDate: "2026-10-22T00:00:00",
  dateRange: "October 10–22, 2026",
  duration: "10 hotel nights",
  highlights: [
    "Round-trip airfare as specified in the confirmed package",
    "5 nights in Madinah · 5-star hotels minutes from Masjid an-Nabawi",
    "5 nights in Makkah · 5-star hotels walking distance to the Haram",
    "Haramain high-speed train between the two holy cities",
    "Guided historical & ziyarah tours with knowledgeable scholars",
    "Daily breakfast at the hotel",
    "Educational pre-departure and on-the-ground seminars",
    "Flexible payment plans available (subject to timing)",
    "Student pricing available",
    "Complimentary ihram and Maqam welcome gift bag",
    "24/7 group support from departure to return",
  ],
};

export const WHY_TRAVEL = [
  { title: "Community-Led Support", body: "Travel as a community, not a tour group. Real connection from departure to return.", icon: "users" },
  { title: "Educational Seminars", body: "Pre-departure classes and on-the-ground lessons so every rite is performed with knowledge.", icon: "book" },
  { title: "Guided Historical Tours", body: "Walk the lands of the Sīrah with knowledgeable guides in Makkah and Madinah.", icon: "map" },
  { title: "5-Star Hotels Near the Haram", body: "Premium accommodations within walking distance of the Sacred Mosque and Masjid an-Nabawi.", icon: "building" },
  { title: "Haramain High-Speed Train", body: "Comfortable, modern transport between Makkah and Madinah — no exhausting bus journeys.", icon: "train" },
  { title: "Gift Bag & Complimentary Ihram", body: "Every traveller receives a thoughtfully curated Maqam welcome bag and ihram.", icon: "gift" },
  { title: "24/7 Group Support", body: "Dedicated team members available around the clock for every traveller.", icon: "shield" },
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/32290182/pexels-photo-32290182.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Pilgrims performing tawaf around the Ka'bah" },
  { url: "https://images.pexels.com/photos/20735113/pexels-photo-20735113.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Masjid an-Nabawi, Madinah" },
  { url: "https://images.pexels.com/photos/36573970/pexels-photo-36573970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "The Sacred House — al-Ka'bah" },
  { url: "https://images.pexels.com/photos/610683/pexels-photo-610683.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Haramain high-speed train" },
  { url: "https://images.pexels.com/photos/5620451/pexels-photo-5620451.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Community of pilgrims together" },
  // Official hotel photography from Dar Al-Hijra InterContinental (Madinah) and
  // Swissôtel Makkah (Clock Tower) will be added here once licensed imagery is
  // available. Generic stock hotel-room photography (which often features
  // people) is intentionally excluded from Version 1.0.
];

export const WHAT_TO_BRING = [
  { category: "Travel Documents", items: ["Valid passport (6+ months validity)", "Printed visa & flight tickets", "Vaccination records"] },
  { category: "Ihram & Clothing", items: ["1 set of ihram — provided by Maqam (for male travellers)", "Modest, comfortable clothing", "Prayer garment / hijab", "Comfortable walking shoes & sandals"] },
  {
    category: "Personal Essentials",
    items: ["Personal prescription medication", "Basic pain relief medication", "Unscented soap & shampoo", "Toothbrush & miswak", "Small first-aid kit"],
    note: "24-hour pharmacies are widely available in Makkah and Madinah, but travellers should bring enough of their regular medication for the full journey.",
  },
  {
    category: "Electronics",
    items: ["Power bank (carry in your hand luggage per airline battery-safety rules)", "Phone & charging cable"],
    note: "An international travel adapter will be provided by Maqam.",
  },
  { category: "Spiritual Companions", items: ["Pocket Qur'an or app", "Dua book", "Notebook & pen", "Prayer mat"] },
];

export const COMMUNITY_INITIATIVES = [
  {
    title: "New Muslim Umrah Program",
    body: "An initiative to help eligible new Muslims experience Umrah through community support and sponsorship opportunities. This is a growing initiative — funding, selection, and campaigns are not always available.",
    tag: "Growing initiative",
  },
  {
    title: "Youth & Community Initiatives",
    body: "A developing area that may include youth activities, community gatherings, potlucks and barbecues, feeding people experiencing homelessness, volunteer and service initiatives, and brothers' and sisters' gatherings.",
    tag: "In development",
  },
  {
    title: "Maqam Sisters",
    body: "A developing space for sisters-led gatherings and community connection — including possible dinners, tea-and-talk sessions, potlucks, and alumni-led activities.",
    tag: "In development",
  },
  {
    title: "Seminars & Events",
    body: "Umrah preparation seminars, including online Zoom sessions connected to upcoming journeys.",
    tag: "Active",
  },
];

// Concepts under consideration only — not active services.
export const FUTURE_INITIATIVES = [
  { title: "Maqam Moments", body: "A concept under consideration." },
  { title: "Maqam Matrimonial", body: "A concept under consideration." },
];

// Placeholders for future New Muslim Umrah Program content.
export const NEW_MUSLIM_FUTURE_CONTENT = [
  "Campaign videos",
  "Participant stories",
  "Testimonials",
  "Fundraising campaigns",
  "Sponsorship information",
];

export const FAQS = [
  { q: "Who organizes the travel portion of the Umrah?", a: "Maqam Community Initiatives facilitates community organization, education, group coordination, and traveller support. All travel bookings, flights, accommodations, visas, and transportation are provided and managed by Amax Travel Canada, TICO Registration #50027257." },
  { q: "Are payment plans available?", a: "Flexible payment plans may be available for travellers who register early enough before departure. The full balance must be paid no later than 45 days before departure. Travellers registering closer to departure may have different payment requirements based on the remaining time before travel." },
  { q: "Do you offer student pricing?", a: "Student pricing is available to eligible students who provide proof of current enrolment at the time of registration." },
  { q: "What is included in the trip?", a: "Round-trip airfare as specified in the confirmed package, accommodations, ground transportation, Haramain train travel where applicable, guided tours, daily breakfast and the other services expressly listed in the package details. For the October 2026 Umrah specifically, this is 5 nights in Madinah and 5 nights in Makkah — 10 hotel nights in total. Full details, hotels, and inclusions for each trip are confirmed on its dedicated trip page." },
  { q: "What is not included?", a: "Visa fees unless expressly stated, personal expenses, lunches and dinners unless stated, optional activities, travel insurance and any service not specifically listed in the confirmed package." },
  { q: "What if I'm joining from a different city?", a: "Travellers joining the group from outside the designated departure city or flight itinerary may be responsible for arranging and paying for their own connecting travel unless alternative arrangements are confirmed in writing." },
  { q: "What kind of group support is provided?", a: "Our team is with you 24/7 from departure to return — including a dedicated WhatsApp group, on-the-ground coordinators, and access to educators throughout the journey." },
  { q: "What if I've never travelled for Umrah before?", a: "Most of our travellers haven't. Our pre-departure seminars and on-the-ground guidance walk you through every rite — you'll never feel lost." },
  { q: "How do I register?", a: "Use the Register Interest button anywhere on this site to submit a short interest form. Once submitted, you'll be directed to our secure Google Form to complete your full traveller registration. A team member will also follow up with pricing, payment plan options, and next steps." },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/umrah-october-2026", label: "Oct 2026 Umrah" },
  { to: "/community", label: "Community" },
  { to: "/resources", label: "Resources" },
  { to: "/about", label: "About" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const COMPLIANCE_TEXT =
  "Maqam Community Initiatives facilitates community organization, education, group coordination, and traveller support. All travel bookings, travel services, flights, accommodations, visas, transportation, and package fulfillment are provided and managed by Amax Travel Canada, TICO Registration #50027257.";

export const CONTACT_INFO = {
  email: "info@maqamumrah.ca",
  location: "Ottawa, Ontario, Canada",
  regional: [
    { label: "Ottawa Regional Contact", displayPhone: "613-981-4388", telHref: "tel:+16139814388" },
    { label: "Toronto Regional Contact", displayPhone: "647-994-8280", telHref: "tel:+16479948280" },
  ],
  whatsapp: {
    displayNumber: "613-981-4388",
    number: "16139814388",
    url: "https://wa.me/16139814388",
    label: "WhatsApp — International Enquiries",
  },
  instagram: {
    handle: "@maqamumrah",
    url: "https://www.instagram.com/maqamumrah/",
  },
};

export const HERO_IMAGE = "https://images.pexels.com/photos/32290182/pexels-photo-32290182.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920";

// Large image for the homepage emotional-media section.
export const EMOTIONAL_MEDIA_IMAGE =
  "https://images.pexels.com/photos/36573970/pexels-photo-36573970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600";

// ------------------------------------------------------------------
// Pilgrim Resources (public — open to all visitors)
// ------------------------------------------------------------------
export const PREPARE_FOR_UMRAH = [
  { title: "Step-by-Step Umrah Guide", body: "A clear walkthrough of each rite, from ihram to tawaf, sa'i, and completion." },
  { title: "What to Expect", body: "An honest picture of the journey — the crowds, the timings, the pace, and the moments of stillness." },
  { title: "What to Bring", body: "A practical packing checklist covering documents, ihram, essentials, electronics, and spiritual companions." },
  { title: "Ihram Guidance", body: "How to enter the state of ihram, its conditions, and the etiquette to observe within it." },
  { title: "Common Questions", body: "Answers to the questions first-time and returning pilgrims ask most often." },
  { title: "Duas for the Journey", body: "Supplications for different stages — travel, entering the Haram, tawaf, sa'i, and departure." },
  { title: "Makkah & Madinah Etiquette", body: "How to carry yourself with adab in the two holy cities and their sacred mosques." },
];

export const STAY_INFORMED = [
  { title: "Travel Updates", body: "Timely notices that affect upcoming journeys." },
  { title: "Visa Announcements", body: "Changes to Umrah visa requirements and processes as they are announced." },
  { title: "Saudi News", body: "Relevant news from the Kingdom that may affect pilgrims." },
  { title: "Group Announcements", body: "Updates and reminders shared with registered Maqam groups." },
];

// Downloads are placeholders only — no files exist yet.
export const DOWNLOADS = [
  { title: "Packing Checklist", status: "coming-soon" },
  { title: "Umrah Guide", status: "coming-soon" },
  { title: "Duas", status: "coming-soon" },
  { title: "What to Bring", status: "coming-soon" },
  { title: "Group Itinerary", status: "coming-soon" },
  { title: "Emergency Contacts", status: "coming-soon" },
];

export const OUR_MISSION =
  "At Maqam Community Initiatives, our mission is to make the journey of Umrah accessible, spiritually enriching and community-centred. We strive to remove the stress of travel so pilgrims can focus on what truly matters—their worship, learning and connection with Allah.";

// External secure Google Form for full traveller registration.
// This is where passport, DOB, medical, nationality, and other sensitive
// details are collected — never in our website database.
export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/1hHUUfeGIaYO7svZre8vLGKy8JfbyjkU_OKBURrYQudc/viewform";

// Consent text shown wherever the full-registration link is presented.
export const REGISTRATION_CONSENT =
  "Traveller information is collected for registration, travel coordination, accommodation, transportation, safety, and related trip administration. Please review our Privacy Policy before submitting.";

// ------------------------------------------------------------------
// Trust & Testimonials data
// ------------------------------------------------------------------
// AUTHENTICITY: Only real, verified Google Reviews should appear here.
// To add a review, paste an entry using this shape:
// {
//   name: "Full name from Google",         // as it appears on the review
//   initial: "S",                          // first letter for avatar fallback
//   location: "Toronto, ON",               // optional; leave "" if not shown
//   rating: 5,
//   date: "2 months ago",                  // as it appears on Google
//   text: "Exact review text, verbatim.",  // do not edit meaning
//   featured: true,                        // top reviews for Home + featured carousel
//   category: "first-time-umrah",          // see CATEGORY_KEYS below
// }
// ------------------------------------------------------------------
export const COMMUNITY_INTRO =
  "Hundreds of pilgrims have trusted Maqam Community Initiatives to help guide their journey to the House of Allah. Here's what a few members of our community had to say about their experience.";

export const GOOGLE_REVIEWS = [
  {
    name: "Yasmin",
    initial: "Y",
    location: "",
    rating: 5,
    date: "October 2024",
    featured: true,
    category: "first-time-umrah",
    text: "This was my first Umrah, and I honestly could not have asked for a better experience. Everything was so well organized from start to finish. The communication before and during the trip was clear and constant, so I always knew what to expect. I felt safe the entire journey, and the attention to detail was incredible — every little thing was taken care of. Because of that, I was able to fully focus on my ibadah and truly be present in worship. May Allah reward the entire Maqam team.",
  },
  {
    name: "Ahmed",
    initial: "A",
    location: "",
    rating: 5,
    date: "July 2026",
    featured: true,
    category: "first-time-umrah",
    text: "As a first-time pilgrim, I had a lot of questions and some nerves going in. The Maqam team guided me through every step and made sure I understood everything. The environment was so welcoming, and the whole experience was extremely well organized. I never felt lost or on my own. Highly recommend for anyone doing Umrah for the first time.",
  },
  {
    name: "Nasra A.",
    initial: "N",
    location: "",
    rating: 5,
    date: "June 2026",
    featured: true,
    category: "families",
    text: "We travelled as a family and the professionalism of the team was outstanding. They were patient with all of us, including the children and elders, and made the entire journey stress-free. Any time we needed something, the support was there. It gave us the space to focus on our worship together as a family without worrying about the logistics. Truly grateful for everything they did for us.",
  },
  {
    name: "Ismail Farah",
    initial: "I",
    location: "",
    rating: 5,
    date: "October 2024",
    featured: true,
    category: "customer-care",
    text: "The hotels were excellent and close to everything, the transportation was smooth, and the guided tours added so much meaning to the trip. Even the small touches, like the gift bags, showed how much thought went into it. But what stood out most was how caring the staff were the whole time. It turned into a deeply meaningful experience for me. May Allah bless the team.",
  },
  {
    name: "Sagal Abdulle",
    initial: "S",
    location: "",
    rating: 5,
    date: "July 2026",
    featured: false,
    category: "customer-care",
    text: "The team was so helpful throughout the entire process. Communication was clear, they were patient with all my questions, and the support never stopped from the day I registered until we returned home. Thank you Maqam.",
  },
  {
    name: "Ridwan Haque",
    initial: "R",
    location: "",
    rating: 5,
    date: "October 2024",
    featured: true,
    category: "spiritual-experience",
    text: "This was my first Umrah and it was such an educational experience. Everything was well organized, and the guided tours in both Madinah and Makkah helped me understand the history and significance of the places we visited. I came back with so much more knowledge and a deeper connection to my faith.",
  },
  {
    name: "Hanad Sheikh Omar",
    initial: "H",
    location: "",
    rating: 5,
    date: "October 2024",
    featured: false,
    category: "community",
    text: "10000/10 experience. Alhamdulillah.",
  },
  {
    name: "Mohammed",
    initial: "M",
    location: "",
    rating: 5,
    date: "May 2026",
    featured: false,
    category: "organization",
    text: "10/10. Professional and knowledgeable from start to finish.",
  },
];

// Testimonials page categorization
export const REVIEW_CATEGORIES = [
  { key: "first-time-umrah",    label: "First-Time Umrah",     blurb: "Reflections from pilgrims performing Umrah for the first time." },
  { key: "families",            label: "Families",             blurb: "Stories from parents, couples, and families traveling together." },
  { key: "organization",        label: "Organization",         blurb: "Reviews on planning, logistics, and communication." },
  { key: "spiritual-experience",label: "Spiritual Experience", blurb: "Notes on the ibadah, ziyarah, and moments of connection." },
  { key: "community",           label: "Community",            blurb: "The bonds formed on the journey — brothers, sisters, families." },
  { key: "customer-care",       label: "Customer Care",        blurb: "How the Maqam team supported pilgrims day and night." },
];

// Pull-quote blocks used in the Highlight Quotes section.
// Each entry MUST be a real line from a real review in GOOGLE_REVIEWS above.
// Leave this array empty until reviews are added — the section will hide itself.
export const HIGHLIGHT_QUOTES = [];

export const RECURRING_THEMES = [
  { icon: "clipboard-check", title: "Exceptional Organization", body: "Everything was planned and communicated clearly — before, during, and after the journey." },
  { icon: "heart-hand", title: "Focus on Worship", body: "Pilgrims consistently mention being able to focus on ibadah while we handled the logistics." },
  { icon: "hotel", title: "Premium Hotels", body: "Comfortable accommodations within walking distance of the Haramain." },
  { icon: "book-open", title: "Knowledgeable Guides", body: "Educational and spiritually enriching historical & ziyarah tours." },
  { icon: "message-circle", title: "Constant Communication", body: "Regular updates before departure and 24/7 group support throughout the journey." },
  { icon: "users", title: "Family Atmosphere", body: "Many pilgrims describe Maqam as feeling like family, not a tour group." },
  { icon: "shield-check", title: "Safe for First-Time Pilgrims", body: "New Muslims and first-time pilgrims consistently mention how supported they felt." },
  { icon: "sparkles", title: "Lifelong Friendships", body: "Pilgrims often leave with lasting relationships built through shared worship." },
];

export const COMMUNITY_STATS = [
  { label: "Pilgrims Served & Counting",              value: 500, suffix: "+", note: "And growing with every journey" },
  { label: "Years of Community-Led Umrah Experiences",value: 5,   suffix: "", note: "Refined trip after trip" },
  { label: "5-Star Google Rating",                    value: 5.0, decimals: 1, suffix: "★", note: "Verified Google Reviews" },
  { label: "A Growing Global Community",              value: "Global", isText: true, note: "Pilgrims from many nations, one Ummah" },
];

// ============================================================================
// GOOGLE REVIEWS LINK
// Temporary fallback: a Google search for Maqam reviews.
// ▶ TO GO LIVE: once your Google Business Profile is verified, replace the URL
//   below with your official reviews link, e.g.
//   "https://g.page/r/XXXXXXXXXXXX/review"  (or your Maps profile reviews URL).
//   No other code changes are needed — every "Read Google Reviews" button
//   across the site reads from this single constant.
// ============================================================================
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?q=Maqam+Community+Initiatives+reviews";

export const REVIEW_GALLERY = [
  { type: "photo", url: "https://images.pexels.com/photos/32290182/pexels-photo-32290182.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Tawaf around the Ka'bah" },
  { type: "video" },
  { type: "photo", url: "https://images.pexels.com/photos/20735113/pexels-photo-20735113.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Masjid an-Nabawi at maghrib" },
  { type: "photo", url: "https://images.pexels.com/photos/5620451/pexels-photo-5620451.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "The Maqam community" },
  { type: "video" },
  { type: "photo", url: "https://images.pexels.com/photos/36573970/pexels-photo-36573970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "The Sacred House" },
  { type: "photo", url: "https://images.pexels.com/photos/610683/pexels-photo-610683.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200", caption: "Haramain train transfer" },
];
